import { StyledFixedBox } from "./styled";


const StickyPageHeader = ({children, ...rest}) => {
    return (
        <StyledFixedBox shadow="raised" padding={{ mobile: "medium", tablet: "medium", desktop: "none" }} {...rest}>
            {children}
        </StyledFixedBox>
    );
};

export default StickyPageHeader;
